import Molde from "./MoldeTrek";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function SalkantayTrek4d() {

  const tourItemsIncluye = [
  "Información previa al tour: Te reunirás con tu guía de Salkantay en nuestras oficinas (u otro lugar acordado) alrededor de las 18:00 horas para una sesión informativa sobre su tour.",
"Transporte",
"Recojo de su hotel en Cusco.",
"Transporte turístico de Cusco a Challacancha (Soraypampa).",
"Transporte turístico desde Lucmabamba hasta la Hidroeléctrica.",
"Bus Consettur a la ciudadela de Machu Picchu.",
"Bus Consettur de retorno desde la ciudadela de Machu Picchu.",
"Tren turístico Expeditions de Machu Picchu pueblo a Ollantaytambo / Poroy.",
"Transporte turístico de Ollantaytambo / Poroy a Cusco.",
"Personal",
"Guía profesional altamente calificado de habla inglesa y española para el Salkantay Trek.",
"Guía profesional altamente calificado de habla inglesa y española para Machu Picchu.",
"Chef y asistente especializado en cocina de montaña, que preparará las comidas durante nuestra caminata.",
"Tickets de ingreso",
"Tickets de ingreso a Salkantay / Lago Humantay.",
"Tickets de ingreso al Sitio Arqueológico de Machu Picchu.",
"Alojamiento y comidas",
"1ra noche: Soraypampa Sky Lodge, acamparemos bajo la atenta mirada de los Apus, montañas Sagradas Humantay y Salkantay. Tendremos suficiente tiempo contemplando las estrellas a través de tu elegante techo de cristal.",
"2da noche: Cabañas en Chaullay, con cómodas camas y colchones, hoy acamparemos rodeados de las Montañas y con menos frío.",
"3ra noche: Lucmabamba Sky Lodge, en nuestros domos encontrarás una cómoda cama, twin o matrimonial (dependiendo de sus preferencas indicadas). Este día el paisaje es más cálido, rodeado de un bosque nuboso y cerca de familias locales.",
"4ta noche: Hotel en Machupicchu pueblo, Aguas Calientes. Está incluido el Hotel Casa de la Luz de 2 estrellas o similar, conocido por sus habitaciones dobles o triples con baño privado, ducha de agua caliente, WiFi, desayuno y resguardo de equipaje durante su visita a Machu Picchu. Alternativamente, puede actualizar a un hotel de 3 o 4 estrellas si lo solicita.",
"3 desayunos, 3 almuerzos, 3 cenas (vegetariana, vegana, sin gluten, sin coste adicional).",
"Suministro de agua hervida, filtrada y refrigerada desde el primer almuerzo hasta el penúltimo desayuno. Recomendamos traer sus propias botellas de agua (3 litros aproximadamente).",
"Mate de coca todas las mañanas en el camping.",
"Hora del té diaria después de la caminata (3 días).",
"Otros",
"Podemos proporcionarles una bolsa de lona para su equipaje personal, de hasta 5 kg (11,02 lbs), incluido su saco de dormir. Esta bolsa será llevada por nuestros caballos y debe ser devuelta al final del recorrido.",
"Botiquín de primeros auxilios, incluida una botella de oxígeno de emergencia.",
"Servicio de Atención al Cliente las 24 horas: Ofrecemos un servicio telefónico disponible las 24 horas del día."
];
const tourItemsNoIncluye = [
"Los bastones de trekking no están incluidos, pero son muy recomendables para la caminata. Puedes traer el suyo o alquilarlo con nosotros.",
"Bolsa de dormir.",
"Entradas adicionales (Montaña Huayna Picchu, Montaña Machu Picchu o Huchuy Picchu).",
"El primer desayuno y el último almuerzo no están incluidos.",
"Tren de Hidroelectrica a Aguas Calientes.",
"Tickets de ingreso para las aguas termales de Santa Teresa y las aguas termales de Aguas Calientes.",
"Costos adicionales o retrasos fuera de nuestro control, como desastres naturales, condiciones climáticas adversas, modificaciones de itinerario por problemas de salud de los pasajeros (que padecen una enfermedad o problemas de salud), pandemia, cambios en las políticas gubernamentales, inestabilidad política, huelgas, etc."
];
const extras =[
  "Bastones de trekking. ($15.00 USD)",
"Bolsas de dormir 3kg. ($25.00 USD)",
"Desayuno económico en Mollepata. ($10.00 USD)",
"Almuerzo Económico en Machupicchu pueblo. ($15.00 USD)",
"Almuerzo en Sanctuary Lodge (Machupicchu pueblo). ($45.00 USD)",
"Cama simple (personal) en los campamentos. ($50.00 USD)",
"Caballo de carga, límite de peso 20 kg. ($90.00 USD)",
"Caballo de silla, para una persona. ($150.00 USD)",
"Tren de Hidroeléctrica a Agua Calientes. ($36.00 USD)",
"Ingreso a la montaña de Huayna Picchu, sujeto a disponibilidad y horarios: 7:00 am / 8:00 am / 9:00 am / 10:00 am ($60.00 USD)",
"Ingreso a la montaña Machupicchu*, sujeto a disponibilidad y horarios: 7:00 am / 9:00 am ($60.00 USD)",
"Ingreso a la montaña Huchuy Picchu, sujeto a disponibilidad y 5 horarios: 7:00, 8:00, 9:00, 10:00, 11:00 y 12:00 am ($60.00 USD)",
"Tour guiado por la montaña Huayna Picchu o montaña Machupicchu*. ($75.00 USD por grupo)",
"Actualice su servicio de tren Vistadome en el regreso. ($50.00 USD)",
"Actualice su servicio de tren Vistadome Observatory en el regreso. ($75.00 USD)",
"Podemos ayudarle en la reserva de hoteles (estándar y de lujo) en todo el Perú.",
];
const llevar =[
  "Pasaporte original (y carné de estudiante válido si corresponde).",
"Artículos de higiene personal o day Pack.",
"Medicación personal.",
"Chaqueta impermeable/poncho de lluvia.",
"Ropa abrigada, gorro para el sol, gafas de sol y guantes.",
"Botas/zapatos de montaña.",
"Calcetines de senderismo.",
"Ropa casual de montaña para las noches.",
"Camisetas de manga corta o larga.",
"Pantalones cómodos, pantalones de trekking.",
"Chaqueta para el clima frío.",
"Protector solar (recomendado SPF 35).",
"Botellas reutilizables de plástico o metal, o camelbak.",
"Repelente de insectos.",
"Sombrero para el sol.",
"Cámara, videocámara y cargadores.",
"Linterna con batería extra.",
];
const arti_adi=[
  "Bermudas.",
"Bastones de trekking (con punta de goma).",
"Vendas y vendajes.",
"Zapatos/chanclas cómodas.",
"Ropa superior transpirable y de ajuste seco.",
"Sandalias.",
"Traje de baño para las aguas termales.",
"Prismáticos.",
"Dinero extra para gastos personales, propinas (se recomiendan 200 nuevos soles peruanos para el dinero extra).",
];
const importante=[
  "El itinerario puede cambiar según el gobierno peruano, las condiciones climáticas y el estado de salud de los excursionistas.",
"El horario de los trenes puede variar dependiendo de la disponibilidad de la compañía de trenes.",
"Proporcionamos el tren Expedition a Ollantaytambo: si alguien reserva un billete de tren en el último momento, no se garantiza que pueda estar en el mismo tren que el resto del grupo.",
"Si desea cambiar el horario o los boletos de su tren, deberá pagar una tarifa adicional por el transporte de Ollantaytambo a Cusco y por la diferencia de precio del tren.",

];
  return (
    <>
      <Molde
        image={"/images/portada_salkantay_trek.png"}
        title={"SALKANTAY TREK 4D"}
        subtitle={"4 DÍAS"}
        description={
          "Salkantay Trek a Machu Picchu es una de las caminatas más reconocidas del Cusco y de Perú, y sin duda la mejor alternativa al Camino Inca, sí no pudiste reservar ese recorrido. Es ideal para los excursionistas que buscan una experiencia más natural, con impresionantes paisajes andinos, picos nevados, bosques tropicales y selva. No solo disfrutarás de vistas a las montañas, sino que también tendrás la increíble oportunidad de explorar la ciudadela inca de Machu Picchu y sumergirte en su fascinante cultura andina. ¡Muy recomendado!"
        }
        linkForm={"/reservar/citytour-dia"}
        tipoprecio={"Precio por persona"}
        monto={"US$ 1000.00"}
        moneda={"DOLARES"}
        mapa={
          <>
            
            <img className="rounded-lg border-primary-800 border-2" src={`${process.env.PUBLIC_URL}/images/mapa_salkantay_trek.png`} alt="" />
          </>
        }
        itinerario={<>
            <div className="mb-4">
                                <h1 className="font-bold text-primary-800 pb-4">ITINERARIO</h1>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 1 | SALKANTAY TREK</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Caminata Challacancha - Soraypampa</h4>
                                
                                <div className="mt-2 text-primary-800">
                                    <p className="mb-2">Saldremos muy temprano desde vuestro hotel en Cusco, alrededor de las 4:30 horas, para emprender un viaje de 3,5 horas hasta Mollepata. Después de un desayuno ligero, nos dirigiremos a Challacancha (3 800 m / 12 467 pies), donde comienza nuestra caminata hacia Soraypampa (3 900 m / 12 795 pies). Durante el camino disfrutaremos de impresionantes paisajes y vistas panorámicas de los Andes peruanos.</p>
                                    <p className="mb-2">Al llegar a Soraypampa, nos dirigiremos al campamento "Sky Lodges", donde nos espera un delicioso almuerzo preparado por nuestro chef profesional. Posteriormente realizaremos una caminata hasta la laguna Humantay (4 200 m./ 13 780 pies). Aquí tendremos la oportunidad de explorar este hermoso lago color turquesa rodeado de imponentes picos y montañas nevadas.</p>
                                    <p className="mb-2">Después de sumergirnos en la belleza del lago Humantay y capturar fotografías memorables, regresaremos a nuestro campamento en Soraypampa - Sky Lodge (3 900 m. / 12 795 pies). Allí, disfrutaremos de un delicioso té por la tarde y pasaremos la noche, preparándonos para emocionante segundo día en nuestra aventura por Salkantay.</p>
                                </div>
                              </div>
                              <div>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 2 | SALKANTAY TREK</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Salkantay Pampa – Paso Salkantay - Huayracmachay – Chaullay</h4>
                                <div className="mt-2 text-primary-800">
                                    <p className="mb-2">El segundo día representa el tramo más desafiante y frío de la caminata Salkantay a Machu Picchu en 4 días, pero despertar bajo la majestuosidad de los picos nevados circundantes hace que todo valga la pena. Comenzaremos con un hermoso amanecer en Soraypampa, seguido de bebidas calientes y un delicioso desayuno preparado por nuestro chef de montaña. Luego nos dirigiremos hacia el Paso Salkantay (4 630 m. / 15 190 pies) a través de un sendero zigzagueante y empinado de 3 a 4 horas. Aunque el aire se siente un poco escaso por la altitud y el camino duro, quienes estén en buenas condiciones físicas y aclimatados a la altura pueden conquistar el paso sin problemas. También ofrecemos la opción de ir en caballo para aquellos que necesiten asistencia extra.</p>
                                    <p className="mb-2">Luego de un descanso y muchas fotografías junto al increíble nevado, cruzaremos el paso y comenzaremos el descenso hacia Wayracmachay (3 850 m. / 12 631 pies), donde disfrutaremos del almuerzo. Continuaremos hacia nuestro campamento en Chaullay (2 900 m. / 9 514 pies). A lo largo del camino, pasaremos por pequeños pueblos y campamentos dispersos en en valle, lo que nos brindará la oportunidad de experimentar la vida local en estas duras condiciones naturales. Después de una tarde de té, cena y descanso, nos prepararemos para el siguiente día de nuestra aventura.</p>
                                </div>
                              </div>
                              <div>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 3 | SALKANTAY TREK</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Chaullay – La Playa – Santa Teresa – Hidroeléctrica – Machu Picchu pueblo</h4>
                                
                                <div className="mt-2 text-primary-800">
                                    <p className="mb-2">Después de un fortalecedor desayuno preparado por nuestro chef de montaña, emprendemos nuestro viaje desde Chaullay hasta La Playa (2 060 m. / 6 759 pies), donde haremos una parada para almorzar. A lo largo del camino, el paisaje sufre una notable transformación desde un terreno montañoso a un paisaje de selva exuberante, con arroyos que dan paso a cascadas, puentes rústicos, hermosos paisajes, cantos de aves, etc. Después del almuerzo, viajaremos en automóvil hasta la Planta Hidroeléctrica (1 800 m. / 5 906 pies), que marca el final de la línea de tren de Cusco a Machu Picchu. Desde allí, caminamos por las vías del tren hasta Machu Picchu Pueblo, conocido también como Aguas Calientes (2 040 m. / 6 693 pies), disfrutando de la agradable caminata a la sombra del follaje de la selva y pasaremos justo por debajo de la montaña donde está la ciudadela de Machu Picchu. Al llegar a Aguas Calientes, nos registraremos en nuestro hotel para un merecido descanso. Posteriormente, nos reunimos para cenar en un restaurante local y planificar nuestra visita a Machu Picchu del día siguiente.</p>
                                </div>
                              </div>
                              <div>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 4 | SALKANTAY TREK</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Tour Guiado en Machu Picchu</h4>
                                
                                <div className="mt-2 text-primary-800">
                                    <p className="mb-2">Este será el último día y el día que visitaremos Machu Picchu, comenzaremos con el desayuno en el hotel a las 05:00 am. Luego, nos dirigiremos a la estación de autobuses de Aguas Calientes y viajaremos hasta el ingreso de la ciudad Inca de Machu Picchu. Para ingresar será necesario presentar su pasaporte original, el boleto de ingreso (incluido en el tour), y el carné de estudiante universitario sí requiere. Luego, su guía lo llevará a través de Machu Picchu y sus diversos sitios, ruinas y templos más importantes entre las 8:00 am y las 10:00 am.</p>
                                </div>
                              </div>
                            </>
        }
        galeria={
            <>
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salkan_tr_1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salkan_tr_2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salkan_tr_3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salkan_tr_4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salkan_tr_5.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salkan_tr_6.png`} alt="" />
            </>
          }
        incluye={
          <ul className="space-y-3">
            {tourItemsIncluye.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-green-600 font-bold mt-1">✔</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        
        noIncluye={
          <ul className="space-y-3">
            {tourItemsNoIncluye.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-red-600 font-bold mt-1">✖</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        extras={
          <ul className="space-y-3">
            {extras.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        llevarTrek={
          <ul className="space-y-3">
            {llevar.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        articulo_add={
          <ul className="space-y-3">
            {arti_adi.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        importante={
          <ul className="space-y-3">
          {importante.map((item, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
              <span className="text-yellow-600 font-bold mt-1">❗</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        }

        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
              title={"Dificultad"}
              desc={"Dificil"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"4/10 personas"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"4 Días/3 Noche"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Trekking"}
            />
          </>
        }
        
        TourRecomienda={
                  <>
                    <CardRecomienda
                      img={"/images/montania_colores.png"}
                      title={"MONTAÑA 7 COLORES"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/montania-colores'}
                    />
                    <CardRecomienda
                      img={"/images/valle-vip-5.png"}
                      title={"VALLE VIP"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/valle-vip'}
                    />
                    <CardRecomienda
                      img={"/images/cris-1.png"}
                      title={"CITY TOUR"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/citytour'}
                    />
                    <CardRecomienda
                      img={"/images/maras-moray-4.png"}
                      title={"MARAS-MORAY"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/maras-moray'}
                    />
                  </>
                }
      />
    </>
  );
}
